window.ontech = window.ontech || {};

class LogLevel{
    constructor(name, logLevel) {
        this.name = name;
        this.logLevel = logLevel;
    }
}

// This method is a hack is need to address issue caused by React Modules included by
// Shogun Template
const checkLogger = (loggerToCheck) => {
    if(isUndefinedOrNull(loggerToCheck) || loggerToCheck == window){
        return ontech.log;
    }

    return loggerToCheck;
};

const LogLevels = {
    ALL: new LogLevel('ALL', 0),
    TRACE: new LogLevel('TRACE', 1),
    DEBUG: new LogLevel('DEBUG', 2),
    INFO: new LogLevel('INFO', 3),
    WARN: new LogLevel('WARN', 4),
    ERROR: new LogLevel('ERROR', 5)
};

const formatPrefix = (wholePrefix) => {
    if(isUndefinedOrNull(wholePrefix)){
        return '';
    }

    let prefixToUse = wholePrefix;
    // Reduce prefix to 64 characters or less
    if(prefixToUse.length > 64){
        let prefixParts = wholePrefix.split('.');
        // Compress all parts except last one
        for(let i = 0; i < (prefixParts.length - 1); i++){
            prefixParts[i] = prefixParts[i].substr(0, 1);
            prefixToUse = prefixParts.join('.');
            if(prefixToUse.length < 65){
                break;
            }
        }
    }

    return prefixToUse;
};

/**
 * customLog will output to the log with color
 */
const customLog = (message, color = "black") => {
    switch (color) {
        case "success":
            color = "Green";
            ontech.log.info(`%c${message}`, `color:${color}`);
            break;
        case "info":
            color = "Blue";
            ontech.log.info(`%c${message}`, `color:${color}`);
            break;
        case "debug":
            color = "Purple";
            ontech.log.debug(`%c${message}`, `color:${color}`);
            break;
        case "error":
            color = "Red";
            ontech.log.error(`%c${message}`, `color:${color}`);
            break;
        case "warning":
            color = "Orange";
            ontech.log.warn(`%c${message}`, `color:${color}`);
            break;
        default:
            ontech.log.debug(`%c${message}`, `color:${color}`);
    }
};

class Logger{
    static overriddenMethods = ['debug', 'error', 'info', 'log', 'warn']

    constructor(moduleName) {
        this.prefix = `[${moduleName}] `;

        if (!isEmpty(window.LOG_LEVEL)) {
            this.logLevelToReport = LogLevels[window.LOG_LEVEL];
        }

        if (isUndefinedOrNull(this.logLevelToReport)) {
            this.logLevelToReport = LogLevels.ALL;
        }

        this.originalConsole = window.console || {};

        // Default log method to info
        this.log = (...args) => {
            // If method name is argument 0 then remove it.
            if(Logger.overriddenMethods.includes(args[0])){
                args.splice(0, 1);
            }
            this.info(args);
        }

        // Add proxy methods for all Console Method not already defined.
        Object.keys(this.originalConsole)
            .forEach(key => {
                if (!Logger.overriddenMethods.includes(key)) {
                    this[key] = (args) => this.originalConsole[key](args);
                }
            });

        // Override Original Console with this logger
        window.console = this;
    }

    debug(message, ...data) {
        return checkLogger(this).logLine(
            checkLogger(this).logLevelToReport,
            LogLevels.DEBUG,
            message,
            ...data
        );
    }

    error(message, ...data) {
        return checkLogger(this).logLine(
            checkLogger(this).logLevelToReport,
            LogLevels.ERROR,
            message,
            ...data
        );
    }

    info(message, ...data) {
        return checkLogger(this).logLine(
            checkLogger(this).logLevelToReport,
            LogLevels.INFO,
            message,
            ...data
        );
    }

    logLine(levelToReport, levelRequested, message, ...data){
        const prefixToUse = formatPrefix(this.prefix);
        const logMessage = `[${new Date().toISOString()}] ${prefixToUse}[${levelRequested.name}] ${message}`;

        if(window.LOG_TO_CONSOLE){
            switch (levelRequested){
                case LogLevels.TRACE:
                    this.originalConsole.trace(logMessage, data);
                    break
                case LogLevels.DEBUG:
                    this.originalConsole.debug(logMessage, data);
                    break
                case LogLevels.INFO:
                    this.originalConsole.info(logMessage, data);
                    break
                case LogLevels.WARN:
                    this.originalConsole.warn(logMessage, data);
                    break
                case LogLevels.ERROR:
                    this.originalConsole.error(logMessage, data);
                    break
                default:
                    this.originalConsole.log(logMessage, data);
            }
        }

        return data;
    }

    trace(message, ...data) {
        return checkLogger(this).logLine(
            checkLogger(this).logLevelToReport,
            LogLevels.TRACE,
            message,
            ...data
        );
    }

    warn(message, ...data) {
        return checkLogger(this).logLine(
            checkLogger(this).logLevelToReport,
            LogLevels.WARN,
            message,
            ...data
        );
    }
}

ontech.log = new Logger('');

// *** ontech.logEvent ***
ontech.logEvent = function (event, logData, source, errors) {
    let logCid, logEmail;
    logEmail = false;
    logCid = true;

    if (!window.enableActivityLogging) {
        return;
    }
    try {
        logData = {
            "event": event,
            "sessionId": ontech.getSessionId(),
            "userAgent": navigator.userAgent,
            "referrerUrl": selfOrDefault(document.referrer, "", true),
            "techid cookie": selfOrDefault(ontech.state.get(State.TECH_ID), '[undefined]', true),
            "parent cookie": selfOrDefault(ontech.state.get(State.ParentOrder.NUMBER), '[undefined]', true),
            "agent_id cookie": selfOrDefault(ontech.state.get(State.AGENT_ID), '[undefined]', true),
            "ontech_oss_action": selfOrDefault(ontech.state.get(State.ACTION), '[undefined]', true),
            ...logData
        };

        if (source) {
            logData = {
                ...logData,
                "source": source,
            };
        }

        if (ontech.state.get(State.Customer.ID) && logCid) {
            logData = {
                ...logData,
                "customerId": ontech.state.get(State.Customer.ID),
            };
        }

        if (logEmail && ontech.state.get(State.Customer.EMAIL_ADDRESS)) {
            logData = {
                ...logData,
                "email": ontech.state.get(State.Customer.EMAIL_ADDRESS),
            };
        }

        if (errors) {
            logData = {
                ...logData,
                "errors": errors,
            };
        }

        _makePostCall(
            `${getShopifyUrl()}/event`,
            JSON.stringify(logData),
            (data, status) => {
                // ontech.log.debug(`$$$ activity log: event = "${event}", data = ${data}, status = ${status}`);
            },
            (xhr, desc, err) => {
                ontech.log.debug(xhr);
                ontech.log.error(`Activity Log Error: event = '${event}', desc: '${desc}', Source: '${source}'`, logData);
            });

    } catch (err) {
        ontech.log.error(`$$$ Activity Log Exception: "${err}"`, err);
    }
};